// src/config/constants.js

/**
 * PWA Configuration Constants pulled from ENV
 */

/**
 * Global Application Constants & Environment Settings
 */

// 1. Environment Variables (Injected via CI/CD or .env)
export const APP_VERSION = process.env.REACT_APP_PWA_VERSION || "1.0.0-dev";
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || "seims.helpdesk@saasta.nrf.ac.za";
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";

// 2. Feature Flags / Logic Settings
export const APP_SETTINGS = {
  storeCleanupLogs: process.env.REACT_APP_STORE_CLEANUP_LOGS === "true",
  cleanupLogRetentionDays: Number.parseInt(process.env.REACT_APP_CLEANUP_LOG_RETENTION_DAYS || "30", 10),
};

// 2. Storage Configuration
// Ensure this matches the name used in your IndexedDB initialization
// imported from "@seims/shared/src/constants";

// 3. Haptic (Vibration) Patterns
// Values are in milliseconds [vibrate, pause, vibrate...]
export const VIBRATION_PATTERNS = {
  SHORT: [200],             // Single short buzz
  DOUBLE: [200, 100, 200],  // Two short pulses
  LONG: [500],              // One long buzz
  OFF: 0                    // Disabled
};

// 4. Notification & Quiet Hours Defaults
export const DEFAULT_QUIET_HOURS = {
  start: "22:00",
  end: "07:00"
};

// 5. Network Performance Thresholds (Mbps)
export const NETWORK_THRESHOLDS = {
  HIGH_SPEED: 15,
  STABLE: 5
};

// 6. Lookups & Sync Configuration
// Convert minutes from ENV to Milliseconds for setInterval
export const LOOKUPS_REFRESH_INTERVAL = Number.parseInt(process.env.REACT_APP_LOOKUPS_REFRESH_INTERVAL || "15", 10) * 60 * 1000;

export const FORCE_REFRESH = process.env.REACT_APP_LOOKUPS_FORCE_REFRESH === "true";

// 7. API Timeout (Used in api.js)
export const API_TIMEOUT = 10000; // 10 seconds
